module.exports = "/static/assets/f872c1456958a6110d3bd9d6c4340297.png";